// libs
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
// helpers
import { refreshTokenHelper } from './helpers/refreshToken';
const REFRESH_TOKEN_INTERVAL = 30 * 60 * 1000; // 30 minutes
export default function RefreshToken(props) {
    const navigate = useNavigate();
    const ref = useRef(0);
    const addEventListeners = (callback) => {
        document.addEventListener('visibilitychange', callback);
    };
    const removeEventListeners = (callback) => {
        document.removeEventListener('visibilitychange', callback);
    };
    function startRefreshToken() {
        const cb = (url) => {
            stopRefreshToken();
            props.setAuthenticated(false);
            navigate(url, { replace: true, preventScrollReset: true });
        };
        refreshTokenHelper(cb);
        clearInterval(ref.current);
        ref.current = window.setInterval(() => {
            refreshTokenHelper(cb);
        }, REFRESH_TOKEN_INTERVAL);
    }
    function stopRefreshToken() {
        clearInterval(ref.current);
    }
    function handleVisibilityChange() {
        if (document.visibilityState === 'visible') {
            startRefreshToken();
        }
        else {
            stopRefreshToken();
        }
    }
    useEffect(() => {
        startRefreshToken();
        addEventListeners(handleVisibilityChange);
        return () => {
            stopRefreshToken();
            removeEventListeners(handleVisibilityChange);
        };
    }, []);
    return React.createElement("div", null);
}
